import React, { Suspense } from 'react'
import { connect } from 'react-redux'

import Modal from '.'
import PopupModal from './PopupModal'
import Field from '../fields'
import { Dispatch } from 'redux'
// @ts-ignore
import { AppAction } from './your-app' // Import your app-specific action types here
import useFeatureFlags from 'hooks/useFeatureFlags'

const MODAL_ID = 'addEmarRoundTimingModal'

interface EmarRoundTiming {
  time: string
  title: string
  // Define other properties of the EmarRoundTiming object
}

interface EmarRoundTimingModalProps {
  emarV2ChartEnabled?: boolean
  isOpen: boolean
  fields: EmarRoundTiming
  setFormField: (data: any) => void // Replace 'any' with your form data type
  createItem: (data: any) => void // Replace 'any' with the expected data type
  setLoadedListItem: (list: string, item: any) => void // Replace 'any' with the expected data type
  showToast: (options: { title: string }) => void
  testId?: string
  // addForm: () => void;
}

const handleSubmit = (props: EmarRoundTimingModalProps) => {
  const { createItem, emarV2ChartEnabled, fields, setLoadedListItem, showToast } =
    props

  createItem({
    json: fields,
    onComplete: (resp: any) => {
      showToast({ title: 'Added a round timing' })
      setLoadedListItem('emar-round-timings', resp)
    },
    url: emarV2ChartEnabled
      ? '/emar/legacy/emar-round-timings'
      : 'list/emar-round-timings'
  })
}

export const EmarRoundTimingModal: React.FC<EmarRoundTimingModalProps> = (
  props
) => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_chart'] })?.data
  const emarV2ChartEnabled = flags?.emar_v2_chart?.enabled ?? false
  const modalProps = { ...props, emarV2ChartEnabled }
  const { isOpen, setFormField, testId, ...formProps } = props

  if (!isOpen) return null

  return (
    <PopupModal
      confirmText="Add"
      buttonIcon="PlusOutlined"
      buttonColour="success"
      list="Round Time"
      subtitle="You will see these when you add a medication"
      onConfirm={() => handleSubmit(modalProps)}
      data-testid={
        testId ? `${testId}-emar-round-timing-modal` : 'emar-round-timing-modal'
      }
      {...formProps}
      type="create"
    >
      <div
        style={{ display: 'flex' }}
        data-testid={
          testId
            ? `${testId}-emar-round-timing-fields`
            : 'emar-round-timing-fields'
        }
      >
        <div
          style={{ marginBottom: 20, maxWidth: 116 }}
          data-testid="emar-round-timing-time-field-container"
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="time"
              label="Time"
              required
              layout="column"
              formId={MODAL_ID}
              type="time"
              values={formProps.fields}
              data-testid="emar-round-timing-time-input"
            />
          </Suspense>
        </div>
        <div
          style={{ marginBottom: 20 }}
          data-testid="emar-round-timing-name-field-container"
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="title"
              label="Round Name"
              layout="column"
              maxLength={13}
              placeholder="Eg. morning"
              formId={MODAL_ID}
              type="text"
              values={formProps.fields}
              data-testid="emar-round-timing-name-input"
            />
          </Suspense>
        </div>
      </div>
    </PopupModal>
  )
}

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({
  // addForm: () => dispatch(Actions.addForm({ formId: MODAL_ID }))
})

const wrappedModal = connect(null, mapDispatchToProps)(EmarRoundTimingModal)

export default Modal(wrappedModal, MODAL_ID)
